import { render, staticRenderFns } from "./generalEditor.vue?vue&type=template&id=74b69b82&lang=pug"
import script from "./generalEditor.vue?vue&type=script&lang=js"
export * from "./generalEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports